import axios from "axios";
import {
    URLAPI,
    STATES_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_states: {
        data: [],
        status: 0,
        message: {},
    },
}

const GET_ALL_STATES_SUCCESS = "GET_ALL_STATES_SUCCESS";

export const states_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_STATES_SUCCESS:
            return {
                ...state,
                _get_all_states: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}

export const get_all_states = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${STATES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_STATES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_STATES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_STATES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Ocurrió un error",
                },
            });
        }
    }
}
